import { Box, Typography } from '@mui/material'
import React from 'react'

function SessionBoxCards({background ,text, subText, textColor}) {
  return (
 <Box
                    sx={{ background: background }}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    flexDirection="column"
                  width="180px"
                  height="80px"
                    borderRadius="8px"
                  >
                    <Typography  color={textColor}
                    fontFamily="Inter"
                    fontSize="22px"
                    lineHeight="100%"
                    letterSpacing="0px"
                    fontStyle="normal"
                    style={{ fontWeight: 700 }}>{text}</Typography>
                    <Typography color="#000000"
                    mt={1}
                    fontFamily="Inter"
                    fontSize="14px"
                    lineHeight="100%"
                    letterSpacing="0px"
                    fontStyle="normal"
                    style={{ fontWeight: 400 }}>{subText}</Typography>
                  </Box>

  )
}

export default SessionBoxCards